import actions from "./actions";

const {
    FETCH_EXAM_CALENDAR_LIST,
    FETCH_EXAM_CALENDAR,
    RESET_EXAM_CALENDAR_FORM
} = actions;

const initState = {
    // Stores the list / calendar grid data, pagination info, and total count
    examCalendars: {
        page: 0,
        perPage: 100,
        data: [],
        total: 0
    },
    // Stores the specific Exam Calendar entry being edited or viewed
    examCalendar: { _id: null }
};

const ExamCalendarReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_EXAM_CALENDAR_LIST:
            return {
                ...state,
                examCalendars: data
            };
        case FETCH_EXAM_CALENDAR:
            return {
                ...state,
                examCalendar: data
            };
        case RESET_EXAM_CALENDAR_FORM:
            return {
                ...state,
                examCalendar: initState.examCalendar
            };
        default:
            return state;
    }
};

export default ExamCalendarReducer;